import { render, staticRenderFns } from "./PatientDeviceModal.vue?vue&type=template&id=56156efa&scoped=true"
import script from "./PatientDeviceModal.vue?vue&type=script&lang=js"
export * from "./PatientDeviceModal.vue?vue&type=script&lang=js"
import style0 from "./PatientDeviceModal.vue?vue&type=style&index=0&id=56156efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56156efa",
  null
  
)

export default component.exports